<template>
    <div>
        <p style="line-height: 1.5em;">Please allow 3proj to send you Telegram notifications</p>

        <p>1. Join the <a href="https://t.me/TprojBot" target="_blank">@3proj bot</a></p>
        <p>2. Click "Start" button.</p>
        <p>3. Send the message with email address you use to login 3proj</p>
        <p>4. Wait a minute for confirmation message</p>

        <hr/>

        <center>
            <b-button variant="outline-primary" @click="dontUseTG">I don't use Telegram</b-button>
            <b-button variant="success" @click="$emit('close')" href="https://t.me/TprojBot" target="_blank" class="ml-3">Join 3proj bot
            </b-button>
        </center>

    </div>
</template>

<script>

    /**
     * Tasks object
     */
    export default {

        // Component creation event
        methods: {

            /**
             * Dont use tg
             */
            dontUseTG()
            {
                // Mark as no tg
                this.$dispatch("auth/setActionFeedback", {action: 'telegram-id', value: 'na'})
                this.$emit("close");
            }
        }
    }

</script>
